<template>
		<!-- Client Section -->
		<section class="client-section-two">			
			<div class="container">
				<div class="row">
					<div class="col-md-12 text-center">
						<div class="section-heading sec-header aos" data-aos="fade-up">
							<h2>Testimonials</h2>
							<p>Description highlights the value of client feedback, showcases real testimonials</p>
						</div>
					</div>
				</div>
				<div class="row justify-content-center">
					<div class="col-lg-4 col-md-6 d-flex">
						<div class="client-box w-100 aos" data-aos="fade-up">
							<div class="client-content">
								<div class="rating">
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
								</div>
								<h6>“The best service”</h6>
								<p>
									Versatile and user-friendly platform for freelancers and businesses alike. Its interface is 
									clean and intuitive, making it easy to 
									post jobs, browse profiles, and manage projects. The range of services is impressive,
								</p>
							</div>
							<div class="client-img">
								<a href="#">
									<img class="img-fluid" alt="Image" src="@/assets/img/profiles/avatar-01.jpg">
								</a>
								<div class="client-name">
									<h5>Sophie Moore</h5>
									<h6>Head of Design at Google</h6>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-6 d-flex">
						<div class="client-box w-100 aos" data-aos="fade-up">
							<div class="client-content">
								<div class="rating">
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
								</div>
								<h6>“Awesome Works”</h6>
								<p>
									Excels in providing a quick and easy way to find help for everyday tasks and home repairs. 
									The platform is straightforward, allowing users to post tasks and receive  from local 
								</p>
							</div>
							<div class="client-img">
								<a href="#">
									<img class="img-fluid" alt="Image" src="@/assets/img/profiles/avatar-02.jpg">
								</a>
								<div class="client-name">
									<h5>Mike Hussy</h5>
									<h6>Tech Lead</h6>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-6 d-flex">
						<div class="client-box w-100 aos" data-aos="fade-up">
							<div class="client-content">
								<div class="rating">
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
									<i class="fas fa-star filled me-1"></i>
								</div>
								<h6>“Brilliant Work”</h6>
								<p>
									Offers a comprehensive marketplace for finding local service professionals across 
									a wide range of categories, including home improvement, events, and personal services. 
									The platform is user-friendly, 
								</p>
							</div>
							<div class="client-img">
								<a href="#">
									<img class="img-fluid" alt="Image" src="@/assets/img/profiles/avatar-03.jpg">
								</a>
								<div class="client-name">
									<h5>Tom Beker</h5>
									<h6>Ads Chairman</h6>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- /Client Section -->
		
		<!-- Blog Section -->
		<section class="blog-section blog-section-two">			
			<div class="container">
				<div class="row">
					<div class="col-md-12 text-center aos" data-aos="fade-up">
						<div class="section-heading sec-header">
							<h2>Our Recent News & Blog</h2>
							<p>Here’s a compelling blog description designed to attract readers and provide a clear idea of what they can expect from your blog:</p>
						</div>
					</div>
				</div>
				<div class="row justify-content-center">
					<div class="col-lg-4 col-md-6 d-flex">
						<div class="blog blog-new flex-fill aos" data-aos="fade-up">
							<div class="blog-image">
								<router-link to="/blogs/blog-details"><img class="img-fluid" src="@/assets/img/blog/blog-15.jpg" alt="Post Image"></router-link>
								<div class="date">
									25<span>Dec</span>
								</div>
								<ul class="blog-item">
									<li>
										<div class="post-author">
											<a href="#"><i class="feather-user"></i><span>Hal Lewis</span></a>
										</div>
									</li>
									<li><i class="feather-message-square"></i>Comments (5)</li>
								</ul>
							</div>
							<div class="blog-content mb-0">
								<h3 class="blog-title">
									<router-link to="/blogs/blog-details">Take Advantage of Trial Periods or Consultations</router-link>
								</h3>
								<p>In today’s fast-paced business world, finding the right services to support your growth can be a game...</p>
							</div>
						</div>					
					</div>
					<div class="col-lg-4 col-md-6 d-flex">
						<div class="blog blog-new flex-fill  aos" data-aos="fade-up">
							<div class="blog-image">
								<router-link to="/blogs/blog-details"><img class="img-fluid" src="@/assets/img/blog/blog-16.jpg" alt="Post Image"></router-link>
								<div class="date">
									25<span>Dec</span>
								</div>
								<ul class="blog-item">
									<li>
										<div class="post-author">
											<a href="#"><i class="feather-user"></i><span>JohnDoe</span></a>
										</div>
									</li>
									<li><i class="feather-message-square"></i>Comments (5)</li>
								</ul>
							</div>
							<div class="blog-content mb-0">
								<h3 class="blog-title">
									<router-link to="/blogs/blog-details">Maximize Your Business Potential with the Right Service</router-link>
								</h3>
								<p>One of the biggest advantages of using a service marketplace is the access to a wide range of services.</p>
							</div>
						</div>						
					</div>
					<div class="col-lg-4 col-md-6 d-flex">
						<div class="blog blog-new flex-fill aos" data-aos="fade-up">
							<div class="blog-image">
								<router-link to="/blogs/blog-details"><img class="img-fluid" src="@/assets/img/blog/blog-17.jpg" alt="Post Image"></router-link>
								<div class="date">
									25<span>Dec</span>
								</div>
								<ul class="blog-item">
									<li>
										<div class="post-author">
											<a href="#"><i class="feather-user"></i><span>Greg Avery</span></a>
										</div>
									</li>
									<li><i class="feather-message-square"></i>Comments (5)</li>
								</ul>
							</div>
							<div class="blog-content mb-0">
								<h3 class="blog-title">
									<router-link to="/blogs/blog-details">Specific features and benefits of your service marketplace.</router-link>
								</h3>
								<p>Before hiring a service provider, check their reviews and ratings on the marketplace...</p>
							</div>
						</div>							
					</div>
				</div>
				<div class="text-center mt-4">
					<router-link to="/blogs/blog-list" class="btn btn-primary rounded-pill">View All Blogs</router-link>
				</div>
			</div>
		</section>
		<!-- /Blog Section -->
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
